import { getHospitalInfo } from "@api/hospitalList";
import { getAmbulanceInfo } from "@api/ambulanceList";
import { showWindowMessage } from "@utils/notification";
import { getStream } from "@assets/js/getStream";

export default {
  data() {
    return {
      ambulanceList: [],
      autoCarList: [],
      planeList: [],
      allList: [], // 拿到的所有的车/飞/机列表
    };
  },
  mounted() {
    getStream(
      this.dealAmbulanceStatus,
      this.setConnection,
      this.dealAmbulanceConnectStatus,
      this);
  },
  methods: {
    /**
     * 主要封装了信息管理和设置下面四个二级菜单的跳转
     * */
    showMenuItem(selected, path, title, queryCategory) {
      this.clearActiveStyle();
      const menuState = selected.startsWith("isShowManage") ? this.isShowManageMenus : this.isShowSettingMenus;
      menuState["isSelected" + selected.substring(9)] = true;
      menuState["isShow" + selected.substring(0, 12) + "Item"] = true;
      menuState[selected] = true;
      const query = {
        category: queryCategory,
        selected
      };
      this.$router.push({
        path,
        query
      });

      setTimeout(() => {
        const { fullPath, meta, name, path } = this.$route;
        const params = { fullPath, meta, name, query, path, title };
        this.$store.commit("updateVisitedViews", params);
      }, 200);
    },
    dealAmbulanceConnectStatus(cars) {
      // 上一次和这一次time 是否相同 相同则表示连接不成功
      cars.forEach(car => {
        const { car_id, time, car_plate } = car;
        if (this.lastTimeCarConnectStatus[car_id] === time) {
          this.disconnectCarName = car_plate;
          this.disConnectDialog = true;
        }
        this.lastTimeCarConnectStatus[car_id] = time;
      });
    },
    setConnection(mapData) {
      // 每一次先把所有的连接状态置为false
      Object.keys(this.carObject).forEach(e => {
        this.showConnectStatus[e] = false;
      });
      const connectCars = Object.keys(mapData);
      // 有获取到gps的车辆编号, 则设置为连接成功
      connectCars.forEach(e => {
        this.showConnectStatus[e] = true;
      });
    },
    /**
     * 主要封装了 急救车/无人车/无人机的二级菜单跳转
     * */
    routeSettingHandler(id, type, router, menuObj, category, custom = "") {
      const selectedStr = `isSelected${category}${id}`;
      const itemStr = `isShow${category}Item${id}`;
      menuObj[selectedStr] = true;
      menuObj[itemStr] = true;
      menuObj[`${type}${id}`] = true;
      const query = { category, id, selected: type };
      this.$router.push({ path: router + id, query });
      setTimeout(() => {
        const { fullPath, meta, name, path } = this.$route;
        const car = this.allList.find(e => {
          return e.id === id;
        });
        const customTitle = custom ? `[${custom}]` : "";
        const params = { fullPath, meta, name, query, path, title: `${customTitle}${car?.name} ${car?.idName}` };
        this.$store.commit("updateVisitedViews", params);
      }, 200);
    },
    async getHospitalListAndStyle() {
      try {
        const [hospitalRes, ambulanceRes] = await Promise.all([getHospitalInfo(), getAmbulanceInfo()]);
        if (hospitalRes.code !== 200 || ambulanceRes.code !== 200) return;

        const data = hospitalRes.data;
        const { name, id } = data;
        const allList = ambulanceRes.data;
        const carObject = {};
        const carPlate = {};
        const isShowCarMenus = {};
        const isShowPlaneMenus = {};
        const isShowAutoMobileMenus = {};
        this.allList = allList;
        const autoCarList = allList.filter(item => {
          return item.type === "无人车";
        });

        const planeList = allList.filter(item => {
          return item.type === "无人机";
        });
        const ambulanceList = allList.filter(item => {
          return item.type === "急救车";
        });
        allList.forEach(({ idName, id, name }) => {
          carObject[id] = idName;
          carPlate[id] = name;
        });

        ambulanceList.forEach(({ id }) => {
          isShowCarMenus[`isShowCarItem${id}`] = false;
          isShowCarMenus[`isSelectedCar${id}`] = false;
          isShowCarMenus[`isShowCarRecognition${id}`] = false;
          isShowCarMenus[`isShowCarNavigation${id}`] = false;
          isShowCarMenus[`liveCarCondition${id}`] = false;
        });
        autoCarList.forEach(({ id }) => {
          isShowAutoMobileMenus[`isSelectedAutoMobile${id}`] = false; // 一级菜单是否被选中
          isShowAutoMobileMenus[`isShowAutoMobileItem${id}`] = false; // 是否展开二级菜单
          isShowAutoMobileMenus[`isShowAutoMobileNavigation${id}`] = false; // 导航定位
          isShowAutoMobileMenus[`isShowAutoMobileLive${id}`] = false; // 是否选中急救急况
        });
        // 总共四个属性, 3个是否选中, 一个是否展开
        planeList.forEach(({ id }) => {
          isShowPlaneMenus[`isSelectedPlane${id}`] = false; // 一级菜单是否被选中
          isShowPlaneMenus[`isShowPlaneItem${id}`] = false; // 是否展开二级菜单
          isShowPlaneMenus[`isShowPlaneNavigation${id}`] = false; // 导航定位
          isShowPlaneMenus[`isShowPlaneLive${id}`] = false; // 是否选中急救急况
        });
        // console.log(planeList);
        this.$store.commit("updateHospitalInfo", data);
        this.$store.commit("updateCarObject", carObject);
        this.$store.commit("updateCarPlate", carPlate);
        this.ambulanceList = ambulanceList;
        this.autoCarList = autoCarList;
        this.planeList = planeList;
        this.isShowCarMenus = isShowCarMenus;
        this.isShowPlaneMenus = isShowPlaneMenus;
        this.isShowAutoMobileMenus = isShowAutoMobileMenus;
        this.addHospitalName(name);
        this.addHospitalID(id);
        this.addCarList(allList);
      } catch (error) {
        showWindowMessage(3, error.message, this);
      }
    },
    // 有新的急救车发车信息 // 急救车发车状态
    dealAmbulanceStatus(carList2) {
      const carToStatus = {};
      Object.keys(carList2).forEach(item => {
        carToStatus[carList2[item].car_id] = carList2[item].code;
      });
      this.ambulanceList.forEach(item => { // 随时更改车辆状态
        item.statu = carToStatus[item.id] === 1 ? "发车中" : "等待";
      });
      const carList = Object.values(carList2);
      const sendList = carList.filter(car => {
        return car.code === 1;
      });
      if (sendList.length) {
        const string = [];
        sendList.forEach(({ car_name, car_plate }) => {
          string.push(`${car_name}(${car_plate})`);
        });
        this.sentCarName = string.join("、");
        this.startTip = true;
      }
    },

    // 保存至store的事件
    addCarList(list) {
      this.$store.commit("updateCarList", list);
    },
    addHospitalName(name) {
      this.$store.commit("updateHospitalName", name);
    },
    addHospitalID(id) {
      this.$store.commit("updateHospitalID", id);
    },
    dealUrl(query) {
      switch (query.category) {
        case "car": // 急救车
          this.isShowCarMenus["isSelectedCar" + query.id] = true;
          this.isShowCarMenus["isShowCarItem" + query.id] = true;
          this.isShowCarMenus[query.selected + query.id] = true;
          break;
        case "Plane": // 无人机
          this.isShowPlaneMenus["isSelectedPlane" + query.id] = true;
          this.isShowPlaneMenus["isShowPlaneItem" + query.id] = true;
          this.isShowPlaneMenus[query.selected + query.id] = true;
          break;
        case "autoMobile":
          this.isShowAutoMobileMenus["isSelectedAutoMobile" + query.id] = true;
          this.isShowAutoMobileMenus["isShowAutoMobileItem" + query.id] = true;
          this.isShowAutoMobileMenus[query.selected + query.id] = true;
          break;
        case "setting":
          this.isShowSettingMenus["isSelectedSetting"] = true;
          this.isShowSettingMenus["isShowSettingItem"] = true;
          this.isShowSettingMenus[query.selected] = true;
          break;
        case "manage":
          this.isShowManageMenus["isSelectedManage"] = true;
          this.isShowManageMenus["isShowManageItem"] = true;
          this.isShowManageMenus[query.selected] = true;
          break;
        default:
          break;
      }
    },
    clearActiveStyle() {
      [
        this.isShowCarMenus,
        this.isShowAutoMobileMenus,
        this.isShowManageMenus,
        this.isShowSettingMenus,
        this.isShowPlaneMenus
      ].forEach(menu =>
        Object.keys(menu).forEach(key => {
          menu[key] = false;
        })
      );
    },

    toggleItemMenus(type, id) {
      const menu = this["isShow" + type + "Menus"];
      const code = menu[`isShow${type}Item${id}`];
      this.clearActiveStyle();
      menu[`isSelected${type}${id}`] = true;
      menu[`isShow${type}Item${id}`] = !code;
    },
  },
};
